import anime from "animejs";
import scrollMonitor from "scrollmonitor";
import { animate, inView, scroll, stagger } from "motion";
import Splitting from "splitting";

export default class SP_Home {
    constructor() {
        $ = jQuery;

        setTimeout(() => {
            this.animations();
        }, 1000);

        SP_Home.header_scroll();

        this.logo_animation();
        this.home_products_animation();

        this.header_ani_check();
    }
    static responsive_mode() {
        return window.innerWidth <= 570 ? true : false;
    }
    static banner_down_click(e) {
        jQuery("html, body").animate(
            {
                scrollTop: window.innerHeight,
            },
            600
        );
    }
    header_ani_check() {
        var st = $(window).scrollTop();
        let start_height = window.innerHeight - 40;

        let logo_animation = anime({
            targets: ".ob-header .ob-header-img",
            // width: ["1080px", "330px"],
            width: ["900px", "140px"],
            top: ["35vh", "0vh"],
            elasticity: 1,
            easing: "easeInOutCubic",
            autoplay: false,
        });

        if (st > start_height) {
            $(".ob-header .ob-header-img").css({
                width: "144px",
                top: "0vh",
            });
        }
    }
    static header_scroll() {
        // header hide
        let lastScrollTop = 0;
        let scrollChecker;
        var $ = jQuery;
        // let logo_animation_img = anime({
        //     targets: ".ob-header .ob-header-img img",
        //     // width: ["900px", "140px"],
        //     // top: ["37vh", "2vh"],
        //     elasticity: 1,
        //     easing: "easeInOutCubic",
        //     autoplay: false,
        // });

        $(window).on("scroll", function (event) {
            var st = $(this).scrollTop();
            var header_scroll_wrap = $(".ob-header");
            let start_height = window.innerHeight - 40;

            let logo_animation = anime({
                targets: ".ob-header .ob-header-img",
                // width: ["1080px", "330px"],
                width: ["900px", "140px"],
                top: ["35vh", "0vh"],
                elasticity: 1,
                easing: "easeInOutCubic",
                autoplay: false,
            });

            if (st < window.innerHeight) {
                var scrollPercent = (st / window.innerHeight) * 100;
                scrollPercent = Math.min(100, Math.max(0, scrollPercent)); // Clamp between 0–100

                logo_animation.seek((scrollPercent / 100) * logo_animation.duration);

                $(".ob-header .ob-header-img").removeClass("ob-header-passed");
            } else if (st > start_height) {
                $(".ob-header .ob-header-img").css({
                    width: "144px",
                    top: "0vh",
                });
            }

            if (st > start_height) {
                header_scroll_wrap.addClass("ob-header-hide");
                if (st > lastScrollTop) {
                    if (scrollChecker != "down") {
                        header_scroll_wrap.removeClass("ob-header-scroll-active");

                        scrollChecker = "down";
                    }
                } else {
                    if (scrollChecker != "up") {
                        header_scroll_wrap.addClass("ob-header-scroll-active");

                        scrollChecker = "up";
                    }
                }

                lastScrollTop = st;
            } else {
                header_scroll_wrap.removeClass("ob-header-hide");
                header_scroll_wrap.removeClass("ob-header-scroll-active");
            }
        });
    }
    logo_animation() {
        // scroll('#ob-page', e => {
        //     console.log(e),
        //     {}
        // })
        let header_img_fade = anime({
            targets: ".ob-header .ob-header-img img",
            opacity: [0, 1],
            easing: "easeInOutCubic",
        });

        if (SP_Home.responsive_mode()) {
            let lastScrollTop = 0;
            let scrollChecker;

            $(window).on("scroll", function (event) {
                var st = $(this).scrollTop();
                let start_height = window.innerHeight - 40;

                if (st > start_height / 2) {
                    if (st > lastScrollTop) {
                        if (scrollChecker != "down") {
                            animate(".ob-header-img", {
                                opacity: 1,
                            });
                            scrollChecker = "down";
                        }
                    }
                } else {
                    if (scrollChecker != "up") {
                        animate(".ob-header-img", {
                            opacity: 0,
                        });
                        scrollChecker = "up";
                    }
                }
                lastScrollTop = st;
            });
        } else {
            let logo_animation = anime({
                targets: ".ob-header .ob-header-img",
                // width: ["1080px", "330px"],
                width: ["900px", "140px"],
                top: ["35vh", "0vh"],
                elasticity: 1,
                easing: "easeInOutCubic",
                autoplay: false,
            });

            let logo_animation_img = anime({
                targets: ".ob-header .ob-header-img img",
                // width: ["900px", "140px"],
                // top: ["37vh", "2vh"],
                elasticity: 1,
                easing: "easeInOutCubic",
                autoplay: false,
            });

            let logo_ani_bg = anime({
                targets: ".ob-banner-video",
                opacity: [1, 0],
                // top: ["37vh", "2vh"],
                elasticity: 1,
                easing: "easeInOutCubic",
                autoplay: false,
            });
        }
        //         let scrollPercent = () => {
        //             const bodyST = document.body.scrollTop;
        //             const docST = document.documentElement.scrollTop;
        //             const docSH = document.documentElement.scrollHeight - (document.documentElement.clientHeight * 1.1);
        //             const docCH = document.documentElement.clientHeight;

        //             // console.log(bodyST, docST);
        //             // console.log(docSH, docCH);

        //             return ((docST + bodyST) / (docSH - docCH)) * 100;
        //         };

        //         let logo_animation_seek = () =>
        //             logo_animation.seek((scrollPercent() / 100) * logo_animation.duration);
        //         let logo_animation_img_seek = () =>
        //             logo_animation_img.seek((scrollPercent() / 100) * logo_animation_img.duration);
        //         let logo_animation_bg = () =>
        //             logo_ani_bg.seek((scrollPercent() / 100) * logo_animation_img.duration);

        //         $(document).on("scroll", (e) => {
        //             logo_animation_seek();
        //             logo_animation_img_seek();
        //             logo_animation_bg();
        //         });

        //         logo_animation_seek();
        //         logo_animation_img_seek();
        //         logo_animation_bg();}
        // }
    }
    home_products_animation() {
        inView(
            ".ob-home-new-products",
            () => {
                products_text_tl.play();
                product_images.play();
            },
            { amount: 0.2 }
        );

        // Wrap every letter in a span
        var textWrapper = document.querySelector(".ob-home-new-products .ob-title-wrap .ob-title");
        textWrapper.innerHTML = textWrapper.textContent.replace(
            /\S/g,
            "<span class='letter'>$&</span>"
        );

        var products_text_tl = anime
            .timeline({
                autoplay: false,
            })
            .add({
                targets: ".ob-home-new-products .ob-title-wrap .ob-title .letter",
                translateY: [-100, 0],
                opacity: ["0", "1"],
                easing: "easeOutExpo",
                duration: 1400,
                delay: (el, i) => 30 * i,
            })
            .add(
                {
                    targets: ".ob-home-new-products .ob-title-wrap .ob-content",
                    // translateY: [-20, 0],
                    opacity: ["0", "1"],
                    easing: "easeInOutQuart",
                    duration: 1000,
                },
                "-=900"
            )
            .add(
                {
                    targets: ".ob-home-new-products .ob-title-wrap .ob-btn",
                    // translateY: [-20, 0],
                    opacity: ["0", "1"],
                    easing: "easeInOutQuart",
                    duration: 1000,
                },
                "-=150"
            );

        var product_images = anime({
            targets: ".ob-home-new-products .ob-home-products .ob-products li",
            opacity: ["0", "1"],
            easing: "easeInOutQuart",
            duration: 3000,
            autoplay: false,
            delay: anime.stagger(150),
        });
    }
    animations() {
        Splitting({ target: ".ob-home-partners .ob-heading-wrap .ob-heading" });

        inView(
            ".ob-home-partners",
            () => {
                animate(
                    ".ob-home-partners .ob-heading-wrap .ob-heading .word",
                    { y: [-200, 0], rotate: [30, 0], opacity: [0, 1] },
                    { duration: 1.4, delay: stagger(0.3), ease: [0.16, 1, 0.3, 1] }
                );
                let seq = [[], []];
                animate(
                    ".ob-home-partners .ob-card li img",
                    { y: [-100, 0] },
                    { duration: 1.4, delay: stagger(0.3), ease: [0.16, 1, 0.3, 1] }
                );
                animate(
                    ".ob-home-partners .ob-btn-wrap .ob-btn",
                    { opacity: [0, 1], y: [-100, 0] },
                    { duration: 1.4, ease: [0.16, 1, 0.3, 1] }
                );
            },
            { amount: 0.5 }
        );
    }
}
